import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import render from '@tk/utilities/tk.render';
import TKCompareStore from './tk.compare.store';
import { useStore, waitForStore } from '@tk/utilities/tk.use.store';

export default class TKCompareCategorySwitch extends TKCustomElementFactory {
    store?: TKCompareStore;
    selectField?: HTMLSelectElement;
    protected unsubscribe?: () => void;

    constructor() {
        super();

        this.selectField = this.querySelector('select') || undefined;
    }

    async connectedCallback() {
        if (!this.selectField) return;
        await waitForStore('compareStore');
        this.store = useStore('compareStore') as TKCompareStore;
        await this.render();
        this.unsubscribe = this.store.subscribe(() => this.render());
        this.registerInputListener();
    }

    disconnectedCallback(): void {
        this.unsubscribe && this.unsubscribe();
    }

    registerInputListener() {
        const onInput = this.switch.bind(this);
        this.pushListener({
            event: 'input',
            element: this.selectField!,
            action: onInput,
        });
    }

    switch(event: Event) {
        const target = event.target as HTMLSelectElement;
        this.store?.switchCategory(Number(target.value));
    }

    async render() {
        if (!this.store || !this.selectField) return;
        const { categories, currentCategoryId } = this.store.getState();
        if (!categories) return;
        this.selectField.innerHTML = '';
        categories.forEach((category) => {
            const articleCount = this.store?.getArticleCountByCategoryId(category.id);
            const optionElement = render<HTMLOptionElement>(`
                <option value="${category.id}" ${currentCategoryId === category.id ? 'selected' : ''}>
                    ${category.name} (${articleCount})
                </option>
            `);
            this.selectField?.options.add(optionElement);
        });
    }
}
